import Series from './Series.js';

class ChartSeries extends Array {
    constructor(series, categories) {
        super();

        // unfortunately there is an issue with extending native classes in babel https://github.com/babel/babel/issues/3083
        // probably solved by babel-plugin-transform-builtin-extend
        //this.constructor = ChartSeries;
        //this.__proto__   = ChartSeries.prototype;
        
        if (typeof(categories) === 'undefined') {
            this.categories = [];
        }
        else if (!(categories instanceof Array)) {
            throw new TypeError('Categories must be an array');
        }
        else {
            this.categories = categories;
        }

        if (typeof(series) !== 'undefined' && !(series instanceof Array)) {
            throw new TypeError('Series must be an array');
        }

        if (typeof(series) !== 'undefined') {
            for (let i = 0; i < series.length; i++) {
                this.push(series[i]);
            }
        }
    }

    push(...items) {
        for (let i = 0; i < items.length; i++) {
            const dataSet = items[i];
            if (!(dataSet instanceof Series)){
                throw new TypeError(`all series in dataSet must be an instance inheriting from Series class, error at index ${i}`);
            }
        }

        return super.push.apply(this, items);
    }

    concat(...chartSeries){
        let categories = this.getCategories();
        let series = this.toArray();

        for (let i = 0; i < chartSeries.length; i++) {
            const singleSeries = chartSeries[i];
            if (!(singleSeries instanceof ChartSeries)){
                throw new TypeError(`all series must be an instance inheriting from ChartSeries class, error at index ${i}`);
            }

            categories = categories.concat(singleSeries.getCategories());
            series = series.concat(singleSeries);
        }

        return new ChartSeries(series, categories);
    }

    getCategories() {
        return [].concat(this.categories);
    }

    getSeries(seriesIndex) {
        if (typeof(seriesIndex) !== 'number') {
            throw TypeError('seriesIndex must be an number');
        }

        const dataSeries = this[seriesIndex];
        if (!(dataSeries instanceof Series)) {
            throw Error('seriesIndex contains no Series instance');
        }

        return dataSeries;
    }

    getValue(seriesIndex, dataIndex, dimensionNr) {
        return this.getSeries(seriesIndex).getValue(dataIndex, dimensionNr);
    }

    getDimension(dimensionNr) {
        return this.reduce((acc, cur) => acc.concat(cur.getDimension(dimensionNr)), []);
    }

    applyCallback(dimensionNr, callback, targetThis) {
        if (typeof(callback) !== 'function') {
            throw new TypeError('callback must be an function');
        }

        const dimension = this.getDimension(dimensionNr);
        return callback.apply(targetThis, dimension);
    }

    getSource(seriesIndex, dataIndex) {
        return this.getSeries(seriesIndex).getSource(dataIndex);
    }

    toArray() {
        return [].concat(this);
    }
}

export default ChartSeries;